export enum helpContextEnum {
  EntriesList = 'entriesList',
  EntryDetails = 'entryDetails',
  CreateEntry = 'createEntry',
  EditEntry = 'editEntry',
  Dashboard = 'dashboard',
  AskUser = 'askUser',
}
